import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {

  constructor(
    private snackBar: MatSnackBar) {
  }

  public showSnackBar(message: string, panelClass: string) {
    this.snackBar.open(message, 'Close', {
      horizontalPosition: 'end',
      verticalPosition: 'top',
      duration: 2500,
      panelClass: ['custom-snackbar', panelClass],
    });
  }
}
